import { createSelector } from '@reduxjs/toolkit';

const ramqCallLogs = (state) => state.ramqCallLogs;

export const selectRamqCallLogLoading = () => createSelector(ramqCallLogs, (state) => state.loading);

export const selectRamqLog = () => createSelector(ramqCallLogs, (state) => state.ramqLog);
